<template>

  <div class="center">
    <div v-if="retData.status == 'yes'" class="tip">
      <img src="../../assets/images/global/auth-success.png" alt=""/>
      <p class="suText">检测结果：签名数据验证通过！</p>
    </div>
    <div v-else-if="retData.status == 'expired'" class="tip">
      <img src="../../assets/images/global/auth-fail.png" alt=""/>
      <p class="suText">结果已过期，请重新验签！</p>
    </div>
    <div v-else-if="retData.status == 'no'" class="tip">
      <img src="../../assets/images/global/auth-fail.png" alt=""/>
      <p class="suText">检测结果：签名数据验证未通过！</p>
    </div>

    <div class="info" v-if="retData.status!='expired'">
      <el-tabs v-model="activeName" :stretch="true">
        <el-tab-pane label="签章信息" name="sealInfo" v-if="retData.signInfo ">
          <span slot="label"><i class="el-icon-s-check"></i> 签章信息</span>
          <el-descriptions :column="1" :colon="false" :labelStyle="{'text-align': 'left', 'width': '20%'}">
            <el-descriptions-item label="操作人">{{retData.signInfo.userName}}</el-descriptions-item>
            <el-descriptions-item label="印章名称">{{retData.signInfo.sealName}}</el-descriptions-item>
            <el-descriptions-item label="印章主体">{{retData.signInfo.sealSubject}}</el-descriptions-item>
            <el-descriptions-item label="印章序号">{{retData.signInfo.sealId}}</el-descriptions-item>
            <el-descriptions-item label="签署时间">{{retData.signInfo.signTime}}</el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="证书信息" name="certInfo" v-if="retData.certInfo && retData.status!='no'">
          <span slot="label"><i class="el-icon-bank-card"></i> 证书信息</span>
          <el-descriptions :column="1" :colon="false" :labelStyle="{'text-align': 'left', 'width': '20%'}">
            <el-descriptions-item label="证书序号">{{retData.certInfo.serialNumber}}</el-descriptions-item>
            <el-descriptions-item label="证书主题">{{retData.certInfo.subject}}</el-descriptions-item>
            <el-descriptions-item label="证书颁发者">{{retData.certInfo.issuer}}</el-descriptions-item>
            <el-descriptions-item label="证书有效期">{{retData.certInfo.notBefore}} ~ {{retData.certInfo.notAfter}}</el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
        <el-tab-pane label="篡改信息" name="diffInfo" v-if="retData.diffInfo && retData.status=='no'">
          <span slot="label"><i class="el-icon-bank-card"></i> 篡改信息</span>
          <el-descriptions :column="1" :colon="false" :labelStyle="{'text-align': 'left', 'width': '20%'}">
            <el-descriptions-item label="原内容">{{retData.diffInfo.oldData}}</el-descriptions-item>
            <el-descriptions-item label="更改后">{{retData.diffInfo.newData}}</el-descriptions-item>
          </el-descriptions>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>

</template>


<script>
import { getVerifyDetailInfo } from '@/api/sign/sign'
export default {
  data() {
    return {
      activeName: 'sealInfo',
      sid: null,
      retData:{}
    };
  },
  created() {
    document.title = "签章详情";
    this.sid = this.$route.query.sid;
    this.getInfo();
  },
  mounted() {
  },
  methods: {
    // handleClick(tab, event) {
    //     console.log(tab, event);
    // }

    getInfo(){
      getVerifyDetailInfo({
        sid: this.sid,
      }).then((res) => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          this.retData = res.data;
        }
      })

    }

  }
}
</script>
<style lang="scss" scoped>
.center{
  position: absolute;
  width: 100%;
  height: 100vh;
  margin: auto;
  background-color: white;
  padding-left: 20%;
  padding-right: 20%;
}

.tip {
  position: relative;
  width: 100%;
  text-align: center;
  vertical-align: middle;
  margin-top: 5%;
}

.tip .suText {
  font-size: 16px;
  font-weight: 500;
  color: #3D3D3D;
  margin-top: 20px;
  margin-bottom: 10px;
}

.info {
  position: relative;
  margin-top: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #3D3D3D;
}

td{
  text-align: left;
  height: 40px;
  vertical-align: middle;
}


</style>
